import React from 'react';

/**
 * RefiServiceIcon Icon - Used in serviceSplit page
 */
export const RefiServiceIcon = (): JSX.Element => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.1808 10.707L2.82678 10H12.8774L13.5234 10.707C13.6947 10.8945 13.791 11.1488 13.7911 11.414V14H1.91309V11.414C1.91314 11.1488 2.00944 10.8945 2.1808 10.707V10.707Z"
        stroke="#212121"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M2.82812 10L3.74182 6H11.965L12.8787 10" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 4L7.85268 1L14.7054 4" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.742 12.5C3.99431 12.5 4.19885 12.2761 4.19885 12C4.19885 11.7239 3.99431 11.5 3.742 11.5C3.48969 11.5 3.28516 11.7239 3.28516 12C3.28516 12.2761 3.48969 12.5 3.742 12.5Z"
        fill="#212121"
      />
      <path
        d="M11.9637 12.5C12.216 12.5 12.4205 12.2761 12.4205 12C12.4205 11.7239 12.216 11.5 11.9637 11.5C11.7114 11.5 11.5068 11.7239 11.5068 12C11.5068 12.2761 11.7114 12.5 11.9637 12.5Z"
        fill="#212121"
      />
      <path d="M1.91309 16H4.65416" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.0508 16H13.7919" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default RefiServiceIcon;
